<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="operateStatusSlot" slot-scope="{ row }">
        <el-button @click="showPublishSpeed(row)" type="link" v-if="row.operateStatus == 0">{{publish_status_map[row.operateStatus]}}</el-button>
        <span v-else>{{publish_status_map[row.operateStatus]}}</span>
      </template>
      <template slot="imageSlot" slot-scope="{ row }">
          <el-popover
            placement="right"
            width="430"
            trigger="hover"
          >
            <el-image style="width: 400px;" :src="row.image" fit="cover"></el-image>
            <el-image slot="reference" style="width: 40px; height: 40px" :src="row.image" fit="cover"></el-image>
          </el-popover>
      </template>
      <template slot="prodInfoSlot" slot-scope="{ row }">
        <div style="width:100%;">
            <el-tooltip popper-width="250px" class="item" effect="dark" :content="row.title" placement="top">
              <div class="text-ellipsis">商品名称：{{row.title}}</div>
            </el-tooltip>
            <el-tooltip popper-width="250px" class="item" effect="dark" :content="row.outerId" placement="top">
              <div class="text-ellipsis">款式编码：{{row.outerId}}</div>
            </el-tooltip>
        </div>
      </template>
      <template slot="shopNameSlot" slot-scope="{ row }">
        <el-image v-if="row.shopIcon" style="width: 18px; height: 18px" :src="row.shopIcon"></el-image>
        <span style="margin-left: 2px;flex: 1">{{row.platformName}}：{{ row.shopCount}}</span>
      </template>
      <template slot="staffIdSlot" slot-scope="{ row }">
        <span>{{staffMap[row.staffId]}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";
import {getStaffList} from '@servers/base/user/index.js';

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "startTime", attrs: { label: "铺货时间" } },
        { prop: "image", attrs: { label: "图片",width:'80px' },slot: true },
        { prop: "prodInfo", attrs: { label: "商品信息",width:'250px' },slot: true },
        { prop: "shopName", attrs: { label: "铺货店铺" },slot: true },
        { prop: "operateStatus", attrs: { label: "铺货状态" },slot: true },
        { prop: "staffId", attrs: { label: "铺货人" },slot: true },
        { prop: "totalNum", attrs: { label: "铺货总数" } },
        { prop: "successNum", attrs: { label: "铺货成功数" } },
        { prop: "failedNum", attrs: { label: "铺货失败数" } },
        { prop: "otherNum", attrs: { label: "其他原因数" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
      staffMap:{}
    };
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    publish_status_map() {
      const { PUBLISH_STATUS_MAP }  = prod_center_dictionary;
      return PUBLISH_STATUS_MAP;
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    jumpDetail(rowData) {
       this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id
          }
      })
    },
    showPublishSpeed(rowData) {
      this.setCurrentPage(`${this.routerPrefix}log`);
      this.publishSpeed({publishType: rowData.publishType, resultVisible: true, batchTaskId: rowData.batchTaskId})
    },
    async getStaffData(){
      let res = await getStaffList({
        pageNo: 1,
        pageSize: 9999999
      });
      if (res && res.list) {
        (res.list || []).forEach(item => {
          this.$set(this.staffMap,[item.id],item.accountName)
        })
      }
    },
  },
  created(){
    this.getStaffData();
  }
};
</script>

<style lang="scss" scoped>

</style>
